// @flow
export const baseURL = "/individual-application";

export const enterInformationURL = "/enter-information";
export const individualDentalPlanURL = "/dental-plans";
export const individualVisionPlanURL = "/vision-plans";
export const doneURL = "/done";
